import React from "react";
import "./WeatherApp.css";
import WeatherContent from "./WeatherContent";

export default function WeatherApp() {
  return (
    <div className="WeatherApp">
      <WeatherContent defaultCity="Paris" />
    </div>
  );
}
